<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right list">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <!-- <div class="form-group">
            <label for="a_name">车场名称</label>
            <el-select v-model="search.parkingId" clearable>
              <el-option
                v-for="item in shareParksData"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </div> -->
          <!-- <div class="form-group">
            <label for="a_name">设备编号</label>
            <input
              v-model="search.gatewaySn"
              class="form-control"
              id="a_name"
              type="text"
              placeholder
              size="12"
            />
          </div> -->
          <div class="form-group others">
            <span class="search_btn">
              <!-- <button
                :disabled="!search.parkingId"
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button> -->
            </span>

            <span class="add_btn">
              <button
                :disabled="!search.parkingId"
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addrOrEdit()"
              >
                新增
              </button>
            </span>
            <!-- <span class="add_btn">
              <button
                :disabled="(!search.parkingId)||selectedIds.length==0"
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="batchDel"
              >
                批量删除
              </button>
            </span> -->
            <span class="add_btn">
              <button
                :disabled="!search.parkingId"
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="download"
              >
                导出
              </button>
            </span>
            <span class="add_btn">
              <button
                :disabled="!search.parkingId"
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="onStatusReportBtn"
              >
                状态汇报
              </button>
            </span>
          </div>
        </form>
      </div>

      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-if="search.parkingId"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column label="网关ID" prop="gatewayId"></el-table-column>
          <el-table-column label="网关编号" prop="gatewaySn"></el-table-column>
          <el-table-column label="网关版本" prop="gatewayVersions">
          </el-table-column>
          <el-table-column label="网关等级" prop="grade"></el-table-column>
          <el-table-column label="工作频道" prop="workChannel">
          </el-table-column>
          <el-table-column label="定时汇报" prop="timing"></el-table-column>
          <el-table-column label="信号强度" prop="rssi"></el-table-column>
          <el-table-column label="功率" prop="power"></el-table-column>
          <el-table-column label="网关告警" prop="alarm"></el-table-column>
          <el-table-column label="电量" prop="voltage"></el-table-column>
          <el-table-column
            label="最后通讯时间"
            prop="finalTime"
          ></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <!-- <button
                class="chargingRules"
                type="button"
                v-if="stationManger_btn_heart"
                @click="setHeartTime(scope.row.gatewayId)"
              >
                心跳周期
              </button> -->
              <button
                class="edit"
                type="button"
                @click="addrOrEdit(scope.row.gatewayId)"
              >
                修改
              </button>
              <button
                class="edit"
                type="button"
                @click="onResetGatewayClick(scope.row.gatewayId)"
              >
                重启
              </button>
              <button
                class="edit"
                @click="del(scope.row.gatewayId)"
                type="button"
              >
                删除
              </button>
              <button
                class="delete"
                @click="onLogClick(scope.row)"
                type="button"
              >
                查看日志
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <el-empty description="请先选择左侧的停车场"></el-empty>
        </div>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 添加/修改设备 -->
    <el-dialog
      title="添加/修改网关"
      class="update-gateway-dialog"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="500px"
      @open="openDialog"
      @close="closeDialog"
    >
      <div class="clearfix">
        <el-form
          class="fl"
          style="width: 100%"
          ref="form"
          label-position="right"
          :model="form"
          :rules="rules"
          :label-width="formLabelWidth"
          id="form"
        >
          <el-form-item label="车场名称" prop="parkingId">
            <el-col :span="18">
              <el-select v-model="form.parkingId">
                <el-option
                  v-for="item in shareParksData"
                  :key="item.parkingId"
                  :label="item.parkingName"
                  :value="item.parkingId"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="网关编号" prop="gatewaySn">
            <el-col :span="18">
              <el-input v-model="form.gatewaySn"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="网关等级">
            <el-col :span="18">
              <el-select v-model="form.grade">
                <el-option
                  v-for="[key, value] in Object.entries(gatewayGrade)"
                  :key="key"
                  :label="value"
                  :value="key"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="工作频道" prop="workChannel">
            <el-col :span="18">
              <el-input v-model="form.workChannel"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="定时汇报" prop="timing">
            <el-col :span="18">
              <el-select v-model="form.timing">
                <el-option
                  v-for="[key, value] in Object.entries(gatewayTiming)"
                  :key="key"
                  :value="key"
                  :label="value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="功率控制" prop="power">
            <el-col :span="18">
              <el-select v-model="form.power">
                <el-option
                  v-for="[key, value] in Object.entries(gatewayPower)"
                  :key="key"
                  :value="key"
                  :label="value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-form>

        <!-- <div class="fr" id="areaMap" style="width: 52%;height: 380px;">
					
        </div>-->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrOrEditTrue">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 设置心跳周期 -->
    <!-- <el-dialog
      title="心跳周期"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormHeartTimeVisible"
      width="500px"
    >
      <div class="clearfix">
        <el-form
          class="fl"
          style="width:100%;"
          ref="cycleForm"
          label-position="right"
          :model="heartTime"
          :rules="rules"
          :label-width="formLabelWidth"
        >
          <el-form-item label="时间">
            <el-col :span="18">
              <el-input v-model="heartTime.timer">
                <template slot="append">秒</template>
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormHeartTimeVisible = false">取 消</el-button>
        <el-button type="primary" @click="setHeartTimeTrue">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-drawer
      title="状态汇报"
      :before-close="handleClose"
      :visible.sync="reportDialogVisible"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
    >
      <div class="demo-drawer__content" style="padding: 0 20px">
        <el-form :model="reportForm">
          <el-form-item label="汇报地址" :label-width="formLabelWidth">
            <el-input v-model="reportForm.reportAddress"></el-input>
          </el-form-item>
          <!-- <el-form-item label="参数键名" :label-width="formLabelWidth">
            <el-input v-model="reportForm.name" ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="参数键值" :label-width="formLabelWidth">
            <el-input v-model="reportForm.name" ></el-input>
          </el-form-item>-->
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input v-model="reportForm.mark" type="textarea"></el-input>
          </el-form-item>
          <el-form-item
            label="是否启用"
            style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <el-radio v-model="reportForm.enabledFlag" label="y">是</el-radio>
            <el-radio v-model="reportForm.enabledFlag" label="n">否</el-radio>
          </el-form-item>
        </el-form>
        <div
          class="demo-drawer__footer"
          style="display: flex; justify-content: center; padding-top: 100px"
        >
          <el-button type="primary" @click="onStatusReportSure">确定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
const GATEWAY_GRADE = {
  "0A": "管63车位",
  "0B": "管127车位",
  "0C": "管255车位",
};
const GATEWAY_TIMING = {
  "00": "1分钟",
  "01": "5分钟",
  "02": "10分钟",
  "03": "30分钟",
  "04": "60分钟",
  "05": "120分钟",
  "06": "180分钟",
  "07": "240分钟",
  "08": "300分钟",
  "09": "360分钟",
  10: "420分钟",
  11: "480分钟",
  12: "540分钟",
  13: "600分钟",
  14: "660分钟",
  15: "720分钟",
};
const GATEWAY_POWER = {
  "00": "低",
  "01": "中",
  "02": "高",
  "03": "最高",
};
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  gateways,
  lowerEquip,
  setHeartTime,
  getAllStationList,
  addStation,
  shareParks,
  addGateway,
  gatewayDetail,
  resetGateway,
  updateGateway,
  deleteGateway,
  searchStatusReport,
  addStatusReport,
  updateStatusReport,
} from "@/api/url";

import Page from "../../commons/page";
import AreaTree from "@/page/commons/parking/commons/areaTree.vue";

export default {
  data() {
    return {
      reportDialogVisible: false,
      stationManger_btn_remove: false,
      stationManger_btn_add: false,
      stationManger_btn_edit: false,
      stationManger_btn_heart: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      moduleName: "station",
      form: {
        parkingId: "",
        gatewaySn: "",
        workChannel: "",
        timing: "",
        power: "",
        grade: "",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        gatewaySn: "",
        parkingId: "",
      },
      tableListData: {
        rows: [{ gatewayId: 111, gatewayId: "9999" }],
      },
      tableListDataExcel: {},
      tableListDataAll: {},
      downloadFileds: {
        设备编号: "stationSn",
        设备名称: "name",
        状态: {
          field: "stationStatus",
          callback: (value) => {
            return value == "nomal" ? "正常" : "异常";
          },
        },
        终端数量: "attr1",
        心跳周期: {
          field: "geomagBhPeriod",
          callback: (value) => {
            return value + "秒";
          },
        },
        通信频率: "loraID",
        最后通讯时间: "lastFlowDate",
      },
      formLabelWidth: "100px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      rules: {},
      shareParksData: [],
      gatewayGrade: { ...GATEWAY_GRADE },
      gatewayTiming: { ...GATEWAY_TIMING },
      gatewayPower: { ...GATEWAY_POWER },
      tableLoading: false,
      selectedIds: [],
      reportForm: {},
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableListAll: function () {
      this.$get(getAllStationList()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.tableListDataAll = data.data;
      });
    },

    //下发设备
    lowerEquip(id) {
      this.$postRequest(lowerEquip() + "?stationId=" + id).then((data) => {
        this.$notify({
          title: "成功",
          message: "操作成功!",
          type: "success",
        });
      });
    },
    handleSearchParams(params) {
      return Object.entries(params).reduce((acc, [key, value]) => {
        if (value) {
          acc[key] = value;
        }
        return acc;
      }, {});
    },
    tableList: function (curPage) {
      var _this = this;
      _this.tableLoading = true;
      _this.tableListData.rows = [];
      const params = {
        limit: this.search.pageSize,
        page: curPage,
        parkingId: this.search.parkingId,
        // gatewaySn: this.search.gatewaySn,
      };
      this.$postRequest(gateways(), {
        ...this.handleSearchParams(params),
      })
        .then((data) => {
          // if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页

          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData.rows = data.data.rows;
        })
        .finally(() => {
          _this.tableLoading = false;
        });
    },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((res) => {
        this.shareParksData = res?.data?.data?.rows ?? [];
      });
    },
    addrOrEdit: function (id) {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });
      this.dialogFormVisible = true;
      if (Boolean(id)) {
        this.$get(gatewayDetail() + "/" + id, { gatewayId: id }).then(
          (data) => {
            if (data.status != 200) return _this.$message(data.message);
            this.form = { ...(data?.data ?? {}) };
          }
        );
      } else {
        this.form = {
          parkingId: "",
          gatewaySn: "",
          workChannel: "",
          timing: "",
          power: "",
          grade: "",
        };
      }
    },
    addrOrEditTrue: function () {
      var _this = this;

      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;

          if (!Boolean(_this.form.gatewayId)) {
            _this
              .$postRequest(addGateway(), {
                ..._this.form,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(updateGateway(), {
                ..._this.form,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功",
                });
                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },

    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除该设备？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(deleteGateway() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$message.error("删除失败", { time: 1 });
            _this.$message.success("删除成功", { time: 1 });
            _this.tableList(_this.curIndex);
          });
        }
      );
    },
    onResetGatewayClick(id) {
      this.$putRequest(resetGateway(), {
        gatewayIds: id,
      }).then((res) => {
        if (res.status == 200) {
          this.$message.success("重置成功", { time: 1 });
          this.tableList(this.curIndex);
        } else {
          this.$message.error("重置失败", { time: 1 });
        }
      });
    },
    handleTreeClick: function (node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        // 获取数据
        this.tableList(this.search.pageNumber);
      } else this.search.parkingId = undefined;
    },
    download() {
      this.$downloadFileRequest(
        "/prod-api/park/gateway/export",
        {
          parkingId: this.search.parkingId,
        },
        "网关"
      );
    },

    handleSelectionChange(val) {
      this.selectedIds = val.reduce((a, b) => {
        return a.concat(b.gatewayId);
      }, []);
      console.log("selected rows=>", this.selectedIds.join(","));
    },
    batchDel() {},
    onLogClick(row) {
      const { gatewaySn } = row;
      this.$router.push({
        path: "/main/equipment/station/log",
        query: { gatewaySn },
      });
    },
    onStatusReportBtn() {
      this.reportDialogVisible = true;
      this.getStatusReport();
    },
    getStatusReport() {
      this.$get(searchStatusReport(), {
        parkingId: this.search.parkingId,
      }).then((res) => {
        this.reportForm = res?.data ?? {};
      });
    },
    addStatusReport() {
      this.$postRequest(addStatusReport(), {
        ...this.reportForm,
      }).then((res) => {
        if (res?.status == 200) {
          this.$message.success("添加成功");
        } else {
          this.$message.error(res?.message);
        }
      });
    },
    updateStatusReport() {
      this.$postRequest(updateStatusReport(), { ...this.reportForm}).then((res) => {
        if (res?.status == 200) {
          this.$message.success("修改成功");
        } else {
          this.$message.error(res?.message);
        }
      });
    },
    onStatusReportSure() {
      this.$refs.drawer.closeDrawer();
      if (this.reportForm.id) this.updateStatusReport();
      else this.addStatusReport();
    },
    handleClose() {
      this.reportDialogVisible = false;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
    AreaTree,
  },
  created: function () {},
  mounted: function () {
    this.search.pageNumber = 1;
    // this.tableList(1);
    this.getShareParks();
  },
  destroyed: function () {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

/* 表格美化样式 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
}

/* 表头样式优化 - 简化版本 */
.el-table th {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border: none !important;
  border-bottom: 2px solid #e4e7ed !important;
  transition: background-color 0.2s ease;
}

.el-table th:hover {
  background: #e9ecef !important;
}

/* 表格行悬停效果 - 简化版本 */
.el-table tbody tr:hover > td {
  background: #f8f9fa !important;
}

/* 操作按钮样式美化 - 简化版本 */
.edit,
.delete,
.chargingRules {
  display: inline-block;
  margin: 0 4px;
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  text-decoration: none;
}

.edit {
  background: #409eff;
  color: white;
}

.edit:hover {
  background: #337ecc;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
}

.delete {
  background: #f56c6c;
  color: white;
}

.delete:hover {
  background: #e64242;
  box-shadow: 0 2px 4px rgba(245, 108, 108, 0.2);
}

.chargingRules {
  background: #67c23a;
  color: white;
}

.chargingRules:hover {
  background: #5daf34;
  box-shadow: 0 2px 4px rgba(103, 194, 58, 0.2);
}

/* 表格容器美化 - 简化版本 */
.list-right {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 1px solid #e4e7ed;
  overflow: hidden;
  position: relative;
  padding-bottom: 100px !important; /* 为分页组件留出空间 */
  box-sizing: border-box;
}
</style>
<style>
.station .update-gateway-dialog .el-select {
  width: 100%;
}
</style>
